import BodyMain from "../../components/util/BodyMain";

import { useSelector } from 'react-redux';


const PrivacyPolicy = () => {
    const {language} = useSelector(state => state.configuration);
    

    return(
        <>
            <BodyMain>
                <div style={{padding:'20px'}}>
                
                    {
                        language === 'es' ? 
                            <p style={{fontFamily:'arial', fontSize:12}}>
<b style={{display:'flex', justifyContent:'center', width:'100%', fontSize:'16px'}}>POLÍTICA DE PRIVACIDAD</b>
<br />1. La información que recopilamos y cuándo
<br /><br />Recopilamos y almacenamos información personal sobre ti cuando:
<br />•	Visitas nuestro sitio web.
<br />•	Te registras y utilizas nuestra aplicación y/o sitio web.
<br />•	Subes música a través de nuestra app o página web.
<br />•	Realizas un pago o solicitas un pago mediante nuestros métodos habilitados.
<br />•	Invitas o eres invitado por alguien para usar nuestros servicios.
<br />•	Contactas al soporte al cliente o te comunicas con nosotros por cualquier otro medio.
<br />•	Te conectas con nosotros a través de servicios de terceros.
<br />•	Te conectas a servicios de terceros mediante D Luna.
<br />•	Te suscribes a uno de nuestros boletines.
<br /><br />También podemos recopilar información no personal, como direcciones IP, tipo de navegador y estadísticas de uso del sitio mediante cookies. Consulta la sección 10 “Cookies” para más detalles.
<br /><br />________________________________________
<br /><br />2. Cómo usamos la información recopilada
<br /><br />Usamos tu información para:
<br />•	Administrar tu cuenta y habilitar los servicios de D Luna.
<br />•	Personalizar y mejorar tu experiencia, así como la publicidad dentro y fuera de D Luna.
<br />•	Asegurar la funcionalidad técnica de los servicios y desarrollar nuevos productos.
<br />•	Comunicarnos contigo por motivos relacionados con el servicio, investigación o marketing, previa autorización.
<br />•	Procesar pagos y prevenir fraudes.
<br />•	Cumplir con nuestras obligaciones legales.
<br />•	Proteger los derechos, la propiedad y la seguridad de D Luna, sus usuarios y terceros.
<br /><br />________________________________________
<br /><br />3. Plazo de almacenamiento
<br /><br />Conservaremos tus datos mientras:
<br />•	Utilices los servicios de D Luna.
<br />•	Existan obligaciones legales que lo requieran.
<br />•	Sea necesario para procesar pagos pendientes.
<br />•	Sea requerido para prevenir fraudes o actividades delictivas.
<br /><br />________________________________________
<br /><br />4. Cómo compartimos la información
<br /><br />No vendemos tus datos personales a terceros. Solo compartimos información con fines de:
<br />•	Procesamiento de pagos y solicitudes de retiro.
<br />•	Distribución de tu música en plataformas asociadas.
<br />•	Campañas de marketing, publicidad y boletines (puedes cancelar la suscripción en cualquier momento).
<br />•	Proveedores de servicios que procesan datos en nuestro nombre bajo acuerdos de confidencialidad.
<br />•	Cumplimiento de la ley, solicitudes judiciales y protección de nuestros derechos.
<br />•	Fusiones, adquisiciones o ventas de activos.
<br /><br />________________________________________
<br /><br />5. Transferencia a otros países
<br /><br />Si resides en Suiza o el Espacio Económico Europeo (EEE), tus datos pueden transferirse fuera de esas áreas. Nos aseguramos de que se cumplan los requisitos del GDPR, estableciendo contratos para garantizar la protección de tus datos.
<br /><br />________________________________________
<br /><br />6. Menores de edad
<br /><br />No permitimos que menores de 18 años se registren en D Luna ni recopilamos datos intencionalmente de ellos. Si eres tutor de un menor y crees que hemos recibido su información, contáctanos en <b>dluna@dlunamusic.com</b> para eliminarla.
<br /><br />________________________________________
<br /><br />7. Cómo protegemos tu información
<br /><br />Implementamos medidas administrativas, técnicas y físicas para proteger tu información contra pérdidas, uso indebido, accesos no autorizados y divulgación.
<br />Te recomendamos mantener segura tu contraseña y nombre de usuario.
<br /><br />________________________________________
<br /><br />8. Tus derechos y contacto
<br /><br />Tienes derecho a:
<br />•	Acceder a tus datos personales.
<br />•	Solicitar la corrección o eliminación de datos inexactos.
<br />•	Retirar tu consentimiento para el uso de datos.
<br />•	Presentar quejas ante la autoridad de protección de datos correspondiente.
<br /><br />Para ejercer tus derechos, envía un correo a <b>dluna@dlunamusic.com</b> indicando tu nombre, usuario y correo electrónico registrado.
<br /><br />________________________________________
<br /><br />9. Cambios en la política de privacidad
<br /><br />Podemos modificar esta Política de Privacidad. Si hacemos cambios importantes, te notificaremos por correo o dentro de los servicios de D Luna. Si no estás de acuerdo con los cambios, puedes cerrar tu cuenta.
<br /><br />________________________________________
<br /><br />10. Cookies
<br /><br />Utilizamos cookies propias y de terceros para:
<br />•	Autenticación: reconocer tu inicio de sesión.
<br />•	Preferencias: recordar configuraciones y personalizaciones.
<br />•	Analítica: analizar cómo interactúas con nuestros servicios.
<br />•	Marketing: mostrarte anuncios personalizados.
<br /><br />Tipos de cookies:
<br />•	Estrictamente necesarias: habilitan funciones básicas.
<br />•	Funcionales: mejoran el rendimiento.
<br />•	De rendimiento: analizan la navegación y uso.
<br />•	De publicidad: muestran anuncios relevantes.
<br /><br />Otras tecnologías:
<br />•	Pixel tags/Web beacons: permiten medir actividad en páginas específicas.
<br />•	Identificadores de dispositivos móviles (MDI): nos ayudan a reconocer tu dispositivo.
<br />•	SDKs: bibliotecas de software que mejoran la funcionalidad de la app.
<br /><br />Puedes administrar las cookies desde la configuración de tu navegador, aunque deshabilitarlas podría afectar el funcionamiento de los servicios.
<br /><br />________________________________________
<br /><br />Última actualización: 16 de agosto de 2025
                            </p>
                        :
                            <p style={{fontFamily:'arial', fontSize:12}}>
<b style={{display:'flex', justifyContent:'center', width:'100%', fontSize:'16px'}}>PRIVACY POLICY </b>
<br />1. THE INFORMACION WE COLLECT AND WHEN 
<br />2. HOW WE USE THE INFORMATION COLLECTED 
<br />3. FOR HOW LONG DO WE STORE IT? 
<br />4. HOW WE SHARE INFORMATION 
<br />5. TRANSFER TO OTHER COUNTRIES 
<br />6. CHILDREN 
<br />7. HOW WE PROTECT YOUR INFORMATION 
<br />8. YOUR RIGHTS, HOW TO CONTACT UT AND COMPLAINTS 
<br />9. CHANGES TO THE PRIVACY POLICY 
<br />10. COOKIES 
<br /><br />Introduction 
<br />We at D Luna Music and our affiliates, a United States based company with registered address at 
1909 Valley Ridge Loop, Clermont, FL 34711 and under the Florida Laws, registration number 
L24000020923 FEI/EIN 99-0835013 (we will from now on refer to ourselves as "D Luna", "we", 
"us", “our” and "ours"), are committed to protecting your privacy and handling your personal 
data with transparency and care. If not otherwise defined herein, capitalized terms have the 
meaning given to them in the Terms of Use, available 
at <a href="https://www.dlunamusic.com/termsofuse" target="_blank">https://www.dlunamusic.com/termsofuse</a> (the “Terms”). This privacy policy, which also 
includes the cookie policy and the end user data privacy policy (let's refer to it as “Privacy 
Policy”), explains how we collect, process, use, share, and protect your personal data when you 
use the D Luna Services (as defined in the Terms). This Privacy Policy does not apply to any 
third party services or websites. 
<br /><br />By using D Luna Services, you agree to the terms of this Privacy Policy. 
In connection with the D Luna Services, we collect and store personal information about and 
from you when you:
<br /><br />• Visit our website 
<br />• Register on and use our app and/or website 
<br />• Upload music through our app and/or website 
<br />• Make a payout through our app, website and the provided payout method 
<br />• Make a payment through our app, website and the provided payment methods 
<br />• Invite or have invited someone to use our service 
<br />• Contact customer support or in any other way contact us 
<br />• Connect to us through third party services 
<br />• Connect to third party services via us 
<br />• Sign up to one of our newsletters 
<br /><br />We may also collect non-personal information, such as IP addresses, browser type, website usage 
statistics via cookies so that we can improve D Luna Services and enhance the user experience. 
Please refer to section 10 “Cookies” below for further details  
<br /><br />Registration data 
<br />When you create a user account, we will ask for username, artist name, password, mobile phone 
number, email address, date of birth, address, postal code and country. 
If you connect to the D Luna Services using credentials from a third party like Google or 
Facebook, you authorize us to collect your authentication information, such as your username 
and encrypted access credentials. We may also collect other information available, like your 
name, profile picture, age, country, hometown, email address, date of birth and gender. 
You can also voluntarily provide us with your Soundcloud, Instagram and/or Twitter account 
username. 
<br /><br />Music upload and creator data 
<br />When you upload music via our app or website, some additional personal information is 
provided by you when you do. This includes: 
<br /><br />• Audio files 
<br />• Track/album titles 
<br />• Artwork 
<br />• Artist name 
<br />• Name of songwriter(s) 
<br />• Name of other contributors (if applicable) 
<br />• Information on whether you're a label, artist, manager or producer etc. 
<br /><br />We also collect information about how your music streams on distribution platforms. 
<br /><br />Usage information 
<br />When you use or interact with the D Luna Services, we collect the following information: 
<br /><br />• Information on how you interact with D Luna Services 
<br />• Content that you post to the D Luna Services; and 
<br />• Technical data, which may include URL information, location, session time, cookie data, 
which ad platform you came from, IP address, and the device and network ID you are 
using to access or connect to the D Luna Service. 
<br /><br />Payment Data 
<br />When you make a payout through our third party payment provider, we may receive information 
like personal identification number, name, address, VAT-number and whether you're a private 
person or a business, from them. We only obtain enough information to be able to make the 
payout, to comply with our legal (including, but not limited to, tax) obligations and to prevent 
and detect fraud.  
<br />When you make a payment through a third party provider, we may receive information like 
name, address from them. We only obtain enough information to be able to process the payment, 
comply with applicable laws and third party provider terms as well as provide you with services. 
Information from third party sources 
We may integrate with third party sources from time to time and may receive information about 
you from them. 
<br />If you choose to use features provided by D Luna that connect to your third party online profiles, 
accounts or services, we may collect information upon your approval. For example, if you pre
save (prelove) a D Luna release on Spotify, we may collect information from Spotify about your 
listening activity. 
<br /><br />End User Data  
<br />As part of the D Luna Services provided, D Luna may collect certain personal data from end 
users you engage with – such as email addresses, names (if provided), and general location 
information (“End User Data”) – after the end users have registered and given explicit consent 
to receive updates about your music, related activities, and information about D Luna Services. 
For further details of the End User Data, please see the separate End User Data Policy located at <a href="https://www.dlunamusic.com/enduserdata" target="_blank">https://www.dlunamusic.com/enduserdata</a>
<br />You and D Luna will act as joint data controllers with respect to the collection, storage, and use 
of End User Data. This means both D Luna and you will determine the purposes of processing 
and share responsibility for ensuring that such data is processed in compliance with applicable 
data protection laws. 
<br />We will process your information for the following purposes: 
<br /><br />• To administer your account, to enable and provide the D Luna Services and, if applicable, 
provide integration with a third party. 
<br />• To provide, personalize and improve your experience and any advertising made available 
on or outside the D Luna Service; 
<br />• To make sure the D Luna Service is technically functional and to develop new products 
and services. Analyze your use of the D Luna Service and how you interact with our ads 
to be able to make great business decisions. 
<br />• To communicate with you for D Luna Service related or research purposes via emails, 
notifications, text messages, or other ways of messaging you, which you have agreed to 
receive. 
<br />• To communicate with you, either directly or through one of our partners, for marketing 
and promotional purposes via emails, notifications, or other messages, subject to your 
consent. 
<br />• To promote the D Luna Service, either within or outside the D Luna Service. 
<br />• To process your payouts, payments and prevent or detect fraud. 
<br />• To enforce this Privacy Policy, the Terms of Use and any other terms that you have 
agreed to, including to protect the rights, property, or safety of D Luna, its users, or any 
other person, or the copyright-protected content of the D Luna Service. 
<br />• As otherwise stated in this Privacy Policy. 
<br />The data we collect from you will be held for as long as: 
<br />• You use D Luna Services 
<br />• We have to because of legal reasons and obligations 
<br />• We need to process any payments remaining and/or owed to you 
<br />• We need to, to prevent fraud, stream farming and any criminal activity 
<br /><br />We never share or sell your personal data to third parties for their own purposes. We only do this 
for the purpose of providing you with and enable the D Luna Services as well as provide us with 
services. 
<br /><br />Music platforms/services and partners 
<br />The information you provide us when you register and upload a song via our app and/or website, 
will be used to perform and provide D Luna Services, by delivering it to the music services, 
platforms and partners. When delivering the music to the platforms, we provide them with: 
<br /><br />• Audio file & track/album version (if applicable) 
<br />• ISRC (International Standard Recording Code). A unique code created for every 
individual track. 
<br />• UPC (Universal Product Code). A unique code created to summarize the release on a 
product level. 
<br />• Track/album titles 
<br />• Artwork 
<br />• Artist name and full name 
<br />• Name of contributors (if applicable) 
<br /><br />Payouts 
<br />When requesting to receive a payout, we share your email address, name and phone number with 
the payout provider we have which could be Hyperwallet, Paypal, Zelle or any other provider D 
Luna chooses. We need to share this information with them to be able to facilitate your payout 
and we will collect from you a tax form in order to be able to pay you. 
Marketing and advertising 
<br />We may share your information with advertising partners in order to send you promotional 
communications about D Luna. If you have agreed to receive newsletters from us, you can 
unsubscribe to these at any time, by clicking “unsubscribe” in the bottom of the email. 
Service providers and others 
<br />We may from time to time share your information with service providers to perform functions 
and process user data and help provide D Luna Services, consistent with this Privacy Policy. 
Where a third party processes user data on our behalf (e.g., a hosting service provider), it is 
subject to security and confidentiality obligations consistent with this Privacy Policy and 
applicable law. Where a third party processes user data on its own behalf, its processing is 
subject to its own Privacy Policy and applicable law. 
<br />In addition to the above, we may also share your information with third parties for these limited 
purposes: 
<br /><br />• To allow a merger, acquisition, or sale of all or a portion of our assets 
<br />• To respond to legal process (e.g., a court order or subpoena), if we believe in good faith 
that it is necessary to do so 
<br />• To comply with the requirements of mandatory applicable law 
<br />• To protect the safety of any person 
<br />• To protect the rights and property of D Luna, including to enforce the Agreements and 
any other terms that you have agreed to 
<br />• To address fraud and resolve disputes 
<br />• To address security or technical issues 
<br />• To publish anonymised or pseudonymised data about the use of the D Luna Service 
<br />• To allow other companies in the D Luna group to use your information as specified in 
this Privacy Policy. 
<br /><br />Beginning May 25, 2018, the processing of personal data of users within the European Economic 
Area (EEA) is subject to the EU General Data Protection Regulation (“GDPR”). This section 
summarizes D Luna's grounds for processing personal data under the GDPR, and the rights of 
such users as it relates to D Luna's handling of personal data. 
If you're a resident of Switzerland or the EEA, you understand that your information may be 
transferred to and stored outside of that area. The country it is transferred to might not have the 
same protection laws as your country. However, if we do transfer your information, we will 
make sure that we protect your personal data in accordance with the GDPR requirements and set 
up contracts with those parties to ensure this. 
<br /><br />We do not let children under the age of 18 register with D Luna Services and therefore, we do 
not knowingly collect personal information from children. If you are under the age of 18, please 
do not provide us with any personal information. If you are a guardian of a child under the age of 
18 and become aware that your child has provided personal information to us, please contact us 
at <b>dluna@dlunamusic.com</b> and you may request to access any information stored and/or cancel 
your D Luna Account. 
<br /><br />Your security is important to us. We always do our best to maintain administrative, technical and 
physical safeguards to help protect your personal information from loss, misuse, unauthorized 
access, disclosure, alteration or disclosure.  
<br /><br />Since the Internet can't be 100% secure, make sure you protect your password and username to 
prevent anyone from accessing your information. 
<br /><br />You are always entitled to receive information on data we have on you, free of charge. You also 
have the right to request to be erased and to get any inaccurate personal data blocked or 
corrected. Where we rely on consent to process your data, you can withdraw this consent at any 
time. Contact us! 
<br /><br />To send a request, please contact us at <b>dluna@dlunamusic.com</b> with your name, username and 
the email address you used when you registered with us. 
If you're not happy with how we handle your information, please contact us at <b>dluna@dlunamusic.com</b>  
If you have a complaint in relation to the processing of your data, you have the right to lodge a 
complaint to the supervisory data authority. 
We may make changes to this Privacy Policy. If we make changes, we'll notify you by either 
displaying a notice within the D Luna Service or by sending you an email. If the change is minor, 
we'll just make the changes here. Please make sure you read the Privacy Policy carefully. If you 
do not want to continue using D Luna Services under the new version of the Privacy Policy, 
please terminate your account. 
<br />This cookie policy explains and describes what cookies are and how D Luna employs such 
cookies and other related technologies. This helps us improve your experience with D Luna 
Services.  
<br /><br />11. What are cookies? 
<br />Cookies (not the actual food of course) are text files with small pieces of data that are used to 
identify your computer when you visit a website. For example, think of when you access a 
website and your username and password are auto-filled; cookies provide that login information 
to the website. Cookies help websites recognize your device and remember certain information 
about your preferences or actions. They are widely used to make websites work more efficiently 
and to provide certain information to the website owner. For more information about cookies, 
check out https://www.aboutcookies.org.uk/cookies. 
<br /><br />12. How and why do we use cookies?  
<br />To provide you with the D Luna Services, we use first-party and third-party cookies. We use 
cookies to get a better understanding of how you use D Luna Services so that we can make them 
work as you expect them to.    
<br />We use cookies for different purposes, including: 
<br /><br />1. Authentication: To recognize you when you visit D Luna Services and log in. 
<br />2. Preferences: To remember your preferences and settings. 
<br />3. Analytics: To gather information about how visitors interact with our website, helping us 
improve its performance and user experience. 
<br />4. Marketing: To display personalized content and ads based on your interests. 
<br /><br />12.1 What type of cookies do we use? 
<br />We may use the following types of cookies:  
<br /><br />• Strictly necessary cookies: These cookies are required for the necessary operation and 
functionality of the D Luna Services. 
<br />• Functional cookies: These cookies are used to enhance the performance of D Luna 
Services. Without them, certain functions may not be available. 
<br />• Performance cookies: These cookies show us how our visitors move around D Luna 
Services. This helps us improve our D Luna Services. 
<br />• Targeting or advertising cookies: These cookies may be used to show you relevant 
advertising based on your preferences and interests. 
<br /><br />12.2 Other technologies 
Pixel tags/web beacons: Sometimes we may use pixel tags (also known as clear GIFS or web 
beacons). Pixel tags are tiny, invisible graphics or code snippets embedded in a web page. The 
pixel tags are placed on certain web pages and when you access those web pages, the pixel tag 
generates a generic notice of the visit and permits us to set or read our cookies. They are used 
together with cookies to track activity on a site by a particular device. If you turn off cookies, we 
can only see anonymous website visits. 
<br /><br />Mobile device identifiers (MDI) and software development kits (SDK):  
We may also use or partner with app developer platforms that use mobile software development 
kits (SDK) to collect information, such as mobile identifiers (e.g., IDFAs and Android 
Advertising IDs) but also information about how mobile devices interact with D Luna Service. 
<br />• MDI are unique alphanumeric strings assigned to your mobile device which helps us to 
recognize and distinguish your device from another. 
<br />• SDKs are collections of software tools and libraries used to develop and enhance our 
mobile applications. 
<br /><br />13. Managing cookies 
<br />You can control and manage cookies through your browser settings. You have the option to 
accept or reject cookies, delete existing cookies, or set your browser to notify you when a cookie 
is being sent. However, please note that disabling or blocking certain cookies may affect the 
functionality and performance of D Luna Services. If you use D Luna Services on a mobile 
device, you can limit tracking and targeting in relation to ads. We cannot, however, control these 
opt out processes. 
<br /><br />Last updated: August 16th, 2025 
                            </p>
                    }

                </div>
            </BodyMain>
        </>
    )
}

export default PrivacyPolicy;